import { render, staticRenderFns } from "./ThemesBlock.vue?vue&type=template&id=6f0a8bed&scoped=true"
import script from "./ThemesBlock.vue?vue&type=script&lang=js"
export * from "./ThemesBlock.vue?vue&type=script&lang=js"
import style0 from "./ThemesBlock.vue?vue&type=style&index=0&id=6f0a8bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a8bed",
  null
  
)

export default component.exports